<template>
  <v-card class="card_setting">
    <v-card-title style="background-color: #2769d7; color: #ffffff">
      <v-spacer></v-spacer>
      <h1>สิทธิ์การใช้งาน</h1>
      <v-spacer></v-spacer>
    </v-card-title>
    <!-- Tabs title -->
    <v-tabs v-model="tab" grow dark center-active background-color="secondary">
      <v-tab
        v-for="(item, index) in tab_content"
        :key="index"
        @click="getDataForEachTab(item.value)"
      >
        <h4>{{ item.name }}</h4>
      </v-tab>
    </v-tabs>
    <v-divider></v-divider>
    <!-- Tabs Content -->
    <v-tabs-items v-model="tab">
      <!-- Tab 1 => 'Permission' -->
      <v-tab-item>
        <PermissionTab1Role ref="tab1" />
      </v-tab-item>
      <!-- Tab 2 => 'UserManagement' -->
      <v-tab-item>
        <PermissionTab2UserManagement ref="tab2" />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>
<script>
import PermissionTab1Role from "./PermissionComponents/PermissionTab1Role";
import PermissionTab2UserManagement from "./PermissionComponents/PermissionTab2UserManagement";
export default {
  components: {
    PermissionTab1Role,
    PermissionTab2UserManagement,
  },
  data() {
    return {
      tab: 0,
      tab_content: [
        { name: "จัดการสิทธิ์การใช้งาน", value: 0 },
        { name: "จัดการผู้ใช้งาน", value: 1 },
      ],
    };
  },

  created() {
    const module_name = "permission_setting";
    const func_name = "permission";
    const redirect = { name: "Dashboard", params: { mode: "all" } };
    if (this.$session.get(module_name)) {
      if (this.$session.get(module_name).includes(func_name)) {
        // this.initialMethod();
      } else {
        this.$router.push(redirect);
      }
    } else {
      this.$router.push(redirect);
    }
  },
  computed: {},
  methods: {
    getDataForEachTab(tab) {
      // console.log(tab);
      switch (tab) {
        case 0:
          setTimeout(() => {
            // this.$refs.tab1.getPermissionList();
          }, 100);
          break;
        case 1:
          setTimeout(() => {
            // this.$refs.tab2.getUserList();
          }, 100);
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style></style>
